import api from './client'

export interface Roster {
  id: number
  tutor_id: number
  name: string
  description: string | null
  is_active: boolean
  create_datetime: string | null
}

export interface RosterStudent {
  id: number
  roster_id: number
  student_id: number
  student_name: string | null
  student_email: string | null
  enrolled_date: string | null
  is_active: boolean
}

export interface RosterStudentAddBody {
  student_email: string
  user_name?: string
  initial_password?: string
}

export const rosterApi = {
  list: () => api.get<Roster[]>('/rosters'),
  get: (id: number) => api.get<{ roster: Roster; students: RosterStudent[] }>(`/rosters/${id}`),
  create: (data: { name: string; description?: string }) =>
    api.post<Roster>('/rosters', data),
  addStudent: (rosterId: number, body: RosterStudentAddBody) =>
    api.post(`/rosters/${rosterId}/students`, body),
  removeStudent: (rosterId: number, studentId: number) =>
    api.delete(`/rosters/${rosterId}/students/${studentId}`),
}
